// src/components/pages/instagram/InstagramContents.tsx
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { customAuthAxios } from '@/utils/customAuthAxios';
import { getDjangoToken } from '@/utils/instagram/services/apiService';
import InstagramPostsGrid, { MediaPost } from './components/InstagramPostsGrid';

const InstagramContents: React.FC = () => {
    const { restaurantId } = useParams<{ restaurantId: string }>();
    const [mediaData, setMediaData] = useState<MediaPost[]>([]);
    const [filteredMediaData, setFilteredMediaData] = useState<MediaPost[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [displayMode, setDisplayMode] = useState<'images' | 'videos'>('images');
    const [dateRange, setDateRange] = useState<{ start: string; end: string }>({ start: '', end: '' });

    useEffect(() => {
        if (restaurantId) fetchContentData(restaurantId);
    }, [restaurantId]);

    useEffect(() => {
        if (mediaData.length > 0) {
            applyFilters();
        }
    }, [mediaData, displayMode, dateRange]);

    const fetchContentData = async (restaurantId: string) => {
        try {
            setIsLoading(true);
            const djangoToken = await getDjangoToken();

            console.log('InstagramContents: メトリクスAPI呼び出し');
            const response = await customAuthAxios.get(
                `external_api/instagram-auth/metrics/${restaurantId}/`,
                {
                    headers: { Authorization: `Bearer ${djangoToken}` },
                }
            );

            console.log('InstagramContents: メトリクスAPIレスポンス', response.data);

            // メトリクスAPIからデータを取得
            if (response.data && response.data.metrics) {
                setMediaData(response.data.metrics);
            } else {
                console.warn('InstagramContents: メトリクスデータが空です');
                setMediaData([]);
            }
        } catch (error) {
            console.error('InstagramContents: メトリクス取得エラー', error);
            setMediaData([]);
        } finally {
            setIsLoading(false);
        }
    };

    // フィルタリングロジック
    const applyFilters = () => {
        const filtered = mediaData.filter(post => {
            const type = post.media_type?.toUpperCase();
            const isCorrectType = displayMode === 'images'
                ? (type === 'IMAGE' || type === 'CAROUSEL_ALBUM')
                : (type === 'VIDEO' || type === 'REEL');

            if (!isCorrectType) return false;

            // 日付フィルター
            if (!post.timestamp || (!dateRange.start && !dateRange.end)) return isCorrectType;

            try {
                const postDate = new Date(post.timestamp);
                return (!dateRange.start || postDate >= new Date(dateRange.start)) &&
                    (!dateRange.end || postDate <= new Date(dateRange.end));
            } catch (e) {
                console.error('日付変換エラー:', e);
                return isCorrectType;
            }
        });

        setFilteredMediaData(filtered);
    };

    // フィルター変更ハンドラー
    const handleFilterChange = (mode: 'images' | 'videos') => {
        setDisplayMode(mode);
    };

    const handleDateRangeChange = (start: string, end: string) => {
        setDateRange({ start, end });
    };

    // const isInstagramLogin = loginMethod === 'instagram';
    const isInstagramLogin = false;

    return (
        <InstagramPostsGrid
            mediaData={filteredMediaData}
            isLoading={isLoading}
            title="リーチ別のトップコンテンツ"
            onFilterChange={handleFilterChange}
            onDateRangeChange={handleDateRangeChange}
            isInstagramLogin={isInstagramLogin}
        />
    );
};

export default InstagramContents;